import { render } from "./UserSettings.vue?vue&type=template&id=b45cd892&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"

import "./UserSettings.vue?vue&type=style&index=0&id=b45cd892&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45cd892"]])

export default __exports__